import { LocationProvider } from './patient.model';
import { StringUtils } from '../shared/utils/string-utils';
import { ContactInformation } from '../notification/model/contact-information';
import { patientPhoneToE164 } from '../notification/standalone-patient-contact';
import { DEFAULT_ALERT_CONFIG } from '../configuration/configuration.defaults';

export function locationToProviderContact(location: LocationProvider): ContactInformation {
  const contactNumber =
    patientPhoneToE164(location.phone) ?? `+1${StringUtils.stripNonDigits(location.phone)}`;

  return {
    entityId: location.id,
    locationId: location.id,
    name: location.name,
    contactNumber,
    createdOn: Date.now(),
    isPatient: false,
    fromEpic: true,
  };
}

export function callbackLocationsHeader(count: number, loading: boolean): string {
  if (loading) {
    return 'Loading...';
  }
  return count === 1 ? '1 Callback Location' : `${count} Callback Locations`;
}

export function patientsHeader(
  count: number,
  loading: boolean,
  singular = DEFAULT_ALERT_CONFIG.subjectLabel,
  plural = DEFAULT_ALERT_CONFIG.subjectLabelPlural,
): string {
  if (loading) {
    return 'Loading...';
  }
  return count === 1 ? `1 ${singular}` : `${count} ${plural}`;
}

export function patientsLabel(
  count: number,
  singular = DEFAULT_ALERT_CONFIG.subjectLabel,
  plural = DEFAULT_ALERT_CONFIG.subjectLabelPlural,
): string {
  return count === 1 ? `1 ${singular}` : `${count} ${plural}`;
}

export function usersLabel(count: number): string {
  return count === 1 ? '1 User' : `${count} Users`;
}

export function callbackLocationsLabel(count: number): string {
  return count === 1 ? '1 Callback location' : `${count} Callback locations`;
}

export function alertsHeader(count: number, loading: boolean): string {
  if (loading) {
    return 'Loading...';
  }
  return count === 1 ? '1 Alert' : `${count} Alerts`;
}

export function activeAlertsHeader(count: number, loading: boolean): string {
  if (loading) {
    return 'Loading...';
  }
  return count === 1 ? '1 Active Alert' : `${count} Active Alerts`;
}

export function alertHistoryHeader(
  count: number | null,
  loading: boolean,
  hasRun: boolean,
): string {
  if (!hasRun) {
    return 'Alert History';
  }
  if (loading) {
    return 'Loading...';
  }
  const total = count ?? 0;
  return total === 1 ? '1 Alert History Item' : `${total} Alert History Items`;
}
